import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=362aea56&scoped=true"
import script from "./DeliveryInfo.vue?vue&type=script&lang=js"
export * from "./DeliveryInfo.vue?vue&type=script&lang=js"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=362aea56&prod&lang=stylus&scoped=true"
import style1 from "./DeliveryInfo.vue?vue&type=style&index=1&id=362aea56&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362aea56",
  null
  
)

export default component.exports